import React, { memo, ReactNode } from 'react';
import './HomeButton.css';

type HomeButtonProps = {
  className?: string;
  icon: ReactNode;
  label: string;
  isDisabled?: boolean;
  onClick?: () => void;
};

export const HomeButton: React.FC<HomeButtonProps> = memo(
  ({ className, icon, label, isDisabled, onClick }) => {
    const buttonClasses = `home-button--button ${className} ${
      isDisabled ? 'home-button--disabled' : ''
    }`;

    return (
      <button
        className={buttonClasses}
        onClick={isDisabled ? undefined : onClick}
      >
        {icon}
        <p className="home-button--label">{label}</p>
      </button>
    );
  }
);
